import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Card,
    CardContent,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Button,
    TextField,
    Chip,
    IconButton,
    Divider,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
} from "@mui/material";
import {
    FolderOpen as FolderIcon,
    CloudUpload as UploadIcon,
    Add as AddIcon,
    Description as FileIcon,
    Delete as DeleteIcon,
    Edit as EditIcon,
    Visibility as ViewIcon,
    Save as SaveIcon,
} from "@mui/icons-material";
import { MessageSquare, GitBranch, ArrowRight } from "react-feather";
import { useTranslation } from "react-i18next";
import appConfig from "../config.json";

const KnowledgeBase = () => {
    const { t } = useTranslation();
    const [selectedProject, setSelectedProject] = useState("");
    const [projects, setProjects] = useState([]);
    const [tyloClient, setTyloClient] = useState(null);
    const [loadingProjects, setLoadingProjects] = useState(true);
    const [loadingInstructions, setLoadingInstructions] = useState(false);
    const [savingInstruction, setSavingInstruction] = useState(false);
    const [deletingInstruction, setDeletingInstruction] = useState(false);
    const [uploadingFile, setUploadingFile] = useState(false);
    const [loadingFiles, setLoadingFiles] = useState(false);
    const [savingCondition, setSavingCondition] = useState(false);
    const [loadingConditions, setLoadingConditions] = useState(false);
    const [deletingCondition, setDeletingCondition] = useState(false);
    const [updatingCondition, setUpdatingCondition] = useState(false);
    const [projectInstructions, setProjectInstructions] = useState([]);
    const [projectFiles, setProjectFiles] = useState([]);
    const [projectConditions, setProjectConditions] = useState([]);
    const [newInstruction, setNewInstruction] = useState("");
    const [newCondition, setNewCondition] = useState("");
    const [deleteDialog, setDeleteDialog] = useState({
        open: false,
        instructionId: null,
        isApiInstruction: false,
        instructionText: "",
    });
    const [conditionModal, setConditionModal] = useState({
        open: false,
        description: "",
        condition: "",
        referenceType: "file",
        selectedFile: "",
        selectedInstruction: "",
        isEdit: false,
        editingConditionId: null,
    });
    const [instructions, setInstructions] = useState([
        {
            id: 1,
            text: "Eres un asistente de soporte al cliente profesional. Responde de manera amable, clara y eficiente. Siempre mantén un tono empático y ofrece soluciones prácticas.",
            type: "Instruction",
            date: "Aug 19",
        },
        {
            id: 2,
            text: "Para problemas técnicos, siempre solicita información específica: modelo del dispositivo, versión de la app, pasos que llevaron al error.",
            type: "Instruction",
            date: "Aug 18",
        },
    ]);
    const [conditions, setConditions] = useState([
        {
            id: 1,
            title: "Technical Support Issue",
            description:
                "If user reports app crashes, login issues, or technical problems",
            condition: "If the support request is",
            date: "Aug 20",
        },
        {
            id: 2,
            title: "General Customer Questions",
            description:
                "If user has general questions about service or policies",
            condition: "If the faq-customers.docx",
            date: "Aug 18",
        },
    ]);

    // AI Call specific data
    const [voiceAgents, setVoiceAgents] = useState([
        {
            id: 1,
            name: "carlos",
            description: "male_voice_customer_service",
            type: "voice_agent",
            date: "Aug 20",
            audioFiles: [
                {
                    name: "greeting.mp3",
                    size: "2.1 MB",
                    duration: "0:45",
                    status: "ready",
                },
                {
                    name: "confirmation.mp3",
                    size: "1.8 MB",
                    duration: "0:32",
                    status: "ready",
                },
            ],
        },
        {
            id: 2,
            name: "sofia",
            description: "female_voice_confirmations",
            type: "voice_agent",
            date: "Aug 18",
            audioFiles: [
                {
                    name: "welcome.mp3",
                    size: "1.9 MB",
                    duration: "0:42",
                    status: "ready",
                },
            ],
        },
    ]);

    const [aiCallFiles, setAiCallFiles] = useState([
        {
            id: 1,
            name: "call-scripts.pdf",
            description: "call_scripts_collection",
            type: "document",
            size: "1.3 MB",
            status: "processed",
            date: "Aug 11",
        },
        {
            id: 2,
            name: "emergency-protocols.docx",
            description: "emergency_call_protocols",
            type: "DOCX",
            size: "1.1 MB",
            status: "processed",
            date: "Aug 9",
        },
    ]);

    const [aiCallInstructions, setAiCallInstructions] = useState([
        {
            id: 1,
            text: "Realiza llamadas automatizadas profesionales para confirmar reservas y proporcionar actualizaciones de estado. Mantén un tono cálido, profesional y servicial. Habla claramente del usuario.",
            type: "Instruction",
            date: "Aug 19",
        },
        {
            id: 2,
            text: "En caso de no contestar, esperar, deja un mensaje claro con la información de la reserva y un número de contacto para consultas.",
            type: "Instruction",
            date: "Aug 9",
        },
    ]);

    const [aiCallConditions, setAiCallConditions] = useState([
        {
            id: 1,
            title: "Emergency Call Situation",
            description:
                "If call involves emergency, safety concerns, or urgent assistance",
            condition: "If the emergency protocols apply",
            date: "Aug 3",
        },
    ]);
    const [uploadedFiles, setUploadedFiles] = useState([
        {
            id: 1,
            name: "support-manual.pdf",
            description: "complete_support_manual",
            type: "document",
            size: "2.5 MB",
            status: "processed",
            date: "Aug 20",
        },
        {
            id: 2,
            name: "faq-customers.docx",
            description: "customer_faq",
            type: "DOCX",
            size: "1.1 MB",
            status: "processed",
            date: "Aug 19",
        },
    ]);

    // API configuration
    const API_BASE_URL = appConfig.api_endpoints.whatsapp_ai_url;
    const API_KEY = "a5af540687e5f73a00ad4a6a7545b5cc1ba1fa4c";

    // API functions
    const fetchTyloClientAndProjects = async () => {
        try {
            // First, fetch clients to find Tylo
            const clientsResponse = await fetch(
                `${API_BASE_URL}/clients/?skip=0&limit=100`,
                {
                    headers: {
                        "x-key": API_KEY,
                    },
                }
            );

            if (!clientsResponse.ok) {
                throw new Error("Failed to fetch clients");
            }

            const clientsData = await clientsResponse.json();
            const tyloClientData = clientsData.find(
                (client) => client.name === "Tylo"
            );

            if (!tyloClientData) {
                console.error("Tylo client not found");
                setProjects([]);
                return;
            }

            setTyloClient(tyloClientData);

            // Now fetch projects for Tylo
            setLoadingProjects(true);
            const projectsResponse = await fetch(
                `${API_BASE_URL}/projects/?skip=0&limit=100`,
                {
                    headers: {
                        "x-key": API_KEY,
                    },
                }
            );

            if (!projectsResponse.ok) {
                throw new Error("Failed to fetch projects");
            }

            const allProjects = await projectsResponse.json();
            // Filter projects by Tylo's client ID
            const tyloProjects = allProjects.filter(
                (project) => project.id_client === tyloClientData.id
            );
            setProjects(tyloProjects);
        } catch (error) {
            console.error("Error fetching Tylo data:", error);
            setProjects([]);
        } finally {
            setLoadingProjects(false);
        }
    };

    const fetchProjectInstructions = async (projectId) => {
        if (!projectId) return;

        setLoadingInstructions(true);
        try {
            const response = await fetch(
                `${API_BASE_URL}/projects/${projectId}/instructions/`,
                {
                    headers: {
                        "x-key": API_KEY,
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Failed to fetch project instructions");
            }

            const instructionsData = await response.json();
            setProjectInstructions(instructionsData);
        } catch (error) {
            console.error("Error fetching project instructions:", error);
            setProjectInstructions([]);
        } finally {
            setLoadingInstructions(false);
        }
    };

    const fetchProjectFiles = async (projectId) => {
        if (!projectId) return;

        setLoadingFiles(true);
        try {
            const response = await fetch(
                `${API_BASE_URL}/projects/${projectId}/files/`,
                {
                    headers: {
                        "x-key": API_KEY,
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Failed to fetch project files");
            }

            const filesData = await response.json();
            setProjectFiles(filesData);
        } catch (error) {
            console.error("Error fetching project files:", error);
            setProjectFiles([]);
        } finally {
            setLoadingFiles(false);
        }
    };

    const fetchProjectConditions = async (projectId) => {
        if (!projectId) return;

        setLoadingConditions(true);
        try {
            const response = await fetch(
                `${API_BASE_URL}/projects/${projectId}/conditions/`,
                {
                    headers: {
                        "x-key": API_KEY,
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Failed to fetch project conditions");
            }

            const conditionsData = await response.json();
            setProjectConditions(conditionsData);
        } catch (error) {
            console.error("Error fetching project conditions:", error);
            setProjectConditions([]);
        } finally {
            setLoadingConditions(false);
        }
    };

    const createInstruction = async (projectId, instructionText) => {
        if (!projectId || !instructionText.trim()) return;

        setSavingInstruction(true);
        try {
            const response = await fetch(`${API_BASE_URL}/instructions/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-key": API_KEY,
                },
                body: JSON.stringify({
                    id_project: parseInt(projectId),
                    instruction: instructionText.trim(),
                }),
            });

            if (!response.ok) {
                throw new Error("Failed to create instruction");
            }

            const newInstructionData = await response.json();

            // Add the new instruction to the current list
            setProjectInstructions((prev) => [...prev, newInstructionData]);

            // Clear the form
            setNewInstruction("");

            return newInstructionData;
        } catch (error) {
            console.error("Error creating instruction:", error);
            throw error;
        } finally {
            setSavingInstruction(false);
        }
    };

    const uploadFile = async (projectId, file, description = "") => {
        if (!projectId || !file) return;

        setUploadingFile(true);
        try {
            const formData = new FormData();
            formData.append("id_project", projectId.toString());
            formData.append("name", file.name);
            formData.append("type", file.type.split("/")[1] || "unknown");
            formData.append("description", description || file.name);
            formData.append("upload", file);
            formData.append("x-key", API_KEY);

            const response = await fetch(`${API_BASE_URL}/files/`, {
                method: "POST",
                headers: {
                    "x-key": API_KEY,
                },
                body: formData,
            });

            if (!response.ok) {
                throw new Error("Failed to upload file");
            }

            const newFileData = await response.json();

            // Add the new file to the current list
            setProjectFiles((prev) => [...prev, newFileData]);

            return newFileData;
        } catch (error) {
            console.error("Error uploading file:", error);
            throw error;
        } finally {
            setUploadingFile(false);
        }
    };

    const createCondition = async (
        projectId,
        description,
        condition,
        referenceType,
        referenceId
    ) => {
        if (
            !projectId ||
            !description.trim() ||
            !condition.trim() ||
            !referenceId
        )
            return;

        setSavingCondition(true);
        try {
            const response = await fetch(`${API_BASE_URL}/conditions/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-key": API_KEY,
                },
                body: JSON.stringify({
                    id_project: parseInt(projectId),
                    description: description.trim(),
                    condition: condition.trim(),
                    reference_type: referenceType,
                    id_reference: parseInt(referenceId),
                }),
            });

            if (!response.ok) {
                throw new Error("Failed to create condition");
            }

            const newConditionData = await response.json();

            return newConditionData;
        } catch (error) {
            console.error("Error creating condition:", error);
            throw error;
        } finally {
            setSavingCondition(false);
        }
    };

    const deleteInstruction = async (instructionId) => {
        try {
            const response = await fetch(
                `${API_BASE_URL}/instructions/${instructionId}`,
                {
                    method: "DELETE",
                    headers: {
                        "x-key": API_KEY,
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Failed to delete instruction");
            }

            // Remove the instruction from the current list
            setProjectInstructions((prev) =>
                prev.filter((instruction) => instruction.id !== instructionId)
            );

            return true;
        } catch (error) {
            console.error("Error deleting instruction:", error);
            throw error;
        }
    };

    const deleteCondition = async (conditionId) => {
        try {
            const response = await fetch(
                `${API_BASE_URL}/conditions/${conditionId}`,
                {
                    method: "DELETE",
                    headers: {
                        "x-key": API_KEY,
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Failed to delete condition");
            }

            // Remove the condition from the current list
            setProjectConditions((prev) =>
                prev.filter((condition) => condition.id !== conditionId)
            );

            return true;
        } catch (error) {
            console.error("Error deleting condition:", error);
            throw error;
        }
    };

    const deleteFile = async (fileId) => {
        try {
            const response = await fetch(`${API_BASE_URL}/files/${fileId}`, {
                method: "DELETE",
                headers: {
                    "x-key": API_KEY,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to delete file");
            }

            // Remove the file from the current list
            setProjectFiles((prev) =>
                prev.filter((file) => file.id !== fileId)
            );

            return true;
        } catch (error) {
            console.error("Error deleting file:", error);
            throw error;
        }
    };

    const updateCondition = async (
        conditionId,
        projectId,
        description,
        condition,
        referenceType,
        referenceId
    ) => {
        if (
            !conditionId ||
            !projectId ||
            !description.trim() ||
            !condition.trim() ||
            !referenceId
        )
            return;

        setUpdatingCondition(true);
        try {
            const response = await fetch(
                `${API_BASE_URL}/conditions/${conditionId}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        "x-key": API_KEY,
                    },
                    body: JSON.stringify({
                        id_project: parseInt(projectId),
                        description: description.trim(),
                        condition: condition.trim(),
                        reference_type: referenceType,
                        id_reference: parseInt(referenceId),
                    }),
                }
            );

            if (!response.ok) {
                throw new Error("Failed to update condition");
            }

            const updatedConditionData = await response.json();

            // Update the condition in the current list
            setProjectConditions((prev) =>
                prev.map((cond) =>
                    cond.id === conditionId ? updatedConditionData : cond
                )
            );

            return updatedConditionData;
        } catch (error) {
            console.error("Error updating condition:", error);
            throw error;
        } finally {
            setUpdatingCondition(false);
        }
    };

    useEffect(() => {
        // Fetch Tylo client and its projects on component mount
        fetchTyloClientAndProjects();
    }, []);

    const handleProjectChange = (event) => {
        const projectId = event.target.value;
        setSelectedProject(projectId);

        // Fetch instructions, files, and conditions when project changes
        if (projectId) {
            fetchProjectInstructions(projectId);
            fetchProjectFiles(projectId);
            fetchProjectConditions(projectId);
        } else {
            setProjectInstructions([]);
            setProjectFiles([]);
            setProjectConditions([]);
        }
    };

    const handleAddInstruction = async () => {
        if (!newInstruction.trim() || !selectedProject) {
            setDeleteDialog({
                open: true,
                instructionId: null,
                isApiInstruction: false,
                instructionText:
                    "Por favor ingrese una instrucción y seleccione un proyecto",
                isError: true,
            });
            return;
        }

        try {
            await createInstruction(selectedProject, newInstruction);
            // Success message could be added here
        } catch (error) {
            // Show error dialog instead of alert
            setDeleteDialog({
                open: true,
                instructionId: null,
                isApiInstruction: false,
                instructionText:
                    "Error al guardar la instrucción. Por favor intente nuevamente.",
                isError: true,
            });
        }
    };

    const handleAddCondition = () => {
        setConditionModal({
            open: true,
            description: "",
            condition: "",
            referenceType: "file",
            selectedFile: "",
            selectedInstruction: "",
            isEdit: false,
            editingConditionId: null,
        });
    };

    const handleConditionModalClose = () => {
        setConditionModal({
            open: false,
            description: "",
            condition: "",
            referenceType: "file",
            selectedFile: "",
            selectedInstruction: "",
            isEdit: false,
            editingConditionId: null,
        });
    };

    const handleConditionModalSave = async () => {
        if (
            !conditionModal.description.trim() ||
            !conditionModal.condition.trim() ||
            !selectedProject
        ) {
            setDeleteDialog({
                open: true,
                instructionId: null,
                isApiInstruction: false,
                instructionText:
                    "Por favor complete todos los campos requeridos y seleccione un proyecto",
                isError: true,
            });
            return;
        }

        // Get reference ID based on reference type
        let referenceId = null;
        if (conditionModal.referenceType === "file") {
            if (!conditionModal.selectedFile) {
                setDeleteDialog({
                    open: true,
                    instructionId: null,
                    isApiInstruction: false,
                    instructionText: "Por favor seleccione un archivo",
                    isError: true,
                });
                return;
            }
            const selectedFileObj = projectFiles.find(
                (file) => file.name === conditionModal.selectedFile
            );
            referenceId = selectedFileObj ? selectedFileObj.id : null;
        } else if (conditionModal.referenceType === "instruction") {
            if (!conditionModal.selectedInstruction) {
                setDeleteDialog({
                    open: true,
                    instructionId: null,
                    isApiInstruction: false,
                    instructionText: "Por favor seleccione una instrucción",
                    isError: true,
                });
                return;
            }
            const selectedInstructionObj = projectInstructions.find(
                (inst) =>
                    inst.instruction === conditionModal.selectedInstruction
            );
            referenceId = selectedInstructionObj
                ? selectedInstructionObj.id
                : null;
        }

        if (!referenceId) {
            setDeleteDialog({
                open: true,
                instructionId: null,
                isApiInstruction: false,
                instructionText:
                    "No se pudo encontrar la referencia seleccionada",
                isError: true,
            });
            return;
        }

        try {
            if (conditionModal.isEdit) {
                // Update existing condition
                const updatedConditionData = await updateCondition(
                    conditionModal.editingConditionId,
                    selectedProject,
                    conditionModal.description,
                    conditionModal.condition,
                    conditionModal.referenceType,
                    referenceId
                );
                handleConditionModalClose();
            } else {
                // Create new condition
                const newConditionData = await createCondition(
                    selectedProject,
                    conditionModal.description,
                    conditionModal.condition,
                    conditionModal.referenceType,
                    referenceId
                );

                // Add the new condition to the current list
                setProjectConditions((prev) => [...prev, newConditionData]);
                handleConditionModalClose();
            }
        } catch (error) {
            setDeleteDialog({
                open: true,
                instructionId: null,
                isApiInstruction: false,
                instructionText:
                    "Error al crear la condición. Por favor intente nuevamente.",
                isError: true,
            });
        }
    };

    const handleDeleteInstruction = (
        instructionId,
        isApiInstruction = false,
        instructionText = ""
    ) => {
        // Find instruction text for display
        let displayText = instructionText;
        if (!displayText) {
            if (isApiInstruction) {
                const instruction = projectInstructions.find(
                    (inst) => inst.id === instructionId
                );
                displayText = instruction
                    ? instruction.instruction
                    : "esta instrucción";
            } else {
                const instruction = instructions.find(
                    (inst) => inst.id === instructionId
                );
                displayText = instruction
                    ? instruction.text
                    : "esta instrucción";
            }
        }

        // Show custom dialog
        setDeleteDialog({
            open: true,
            instructionId,
            isApiInstruction,
            instructionText: displayText,
        });
    };

    const confirmDeleteInstruction = async () => {
        const { instructionId, isApiInstruction, isCondition, isFile } =
            deleteDialog;

        if (isCondition) {
            setDeletingCondition(true);
            try {
                await deleteCondition(instructionId);
                // Close dialog on success
                setDeleteDialog({
                    open: false,
                    instructionId: null,
                    isApiInstruction: false,
                    instructionText: "",
                    isCondition: false,
                });
            } catch (error) {
                setDeleteDialog({
                    open: true,
                    instructionId: null,
                    isApiInstruction: false,
                    instructionText:
                        "Error al eliminar la condición. Por favor intente nuevamente.",
                    isError: true,
                    isCondition: false,
                });
            }
            setDeletingCondition(false);
        } else if (isFile) {
            setDeletingCondition(true); // Reuse the same loading state
            try {
                await deleteFile(instructionId);
                // Close dialog on success
                setDeleteDialog({
                    open: false,
                    instructionId: null,
                    isApiInstruction: false,
                    instructionText: "",
                    isFile: false,
                });
            } catch (error) {
                setDeleteDialog({
                    open: true,
                    instructionId: null,
                    isApiInstruction: false,
                    instructionText:
                        "Error al eliminar el archivo. Por favor intente nuevamente.",
                    isError: true,
                    isFile: false,
                });
            }
            setDeletingCondition(false);
        } else {
            setDeletingInstruction(true);

            if (isApiInstruction) {
                // Delete API instruction
                try {
                    await deleteInstruction(instructionId);
                    // Close dialog on success
                    setDeleteDialog({
                        open: false,
                        instructionId: null,
                        isApiInstruction: false,
                        instructionText: "",
                    });
                } catch (error) {
                    setDeleteDialog({
                        open: true,
                        instructionId: null,
                        isApiInstruction: false,
                        instructionText:
                            "Error al eliminar la instrucción. Por favor intente nuevamente.",
                        isError: true,
                    });
                }
            } else {
                // Delete local instruction (fallback data)
                // Simulate loading for consistency
                await new Promise((resolve) => setTimeout(resolve, 500));
                setInstructions(
                    instructions.filter((item) => item.id !== instructionId)
                );
                // Close dialog
                setDeleteDialog({
                    open: false,
                    instructionId: null,
                    isApiInstruction: false,
                    instructionText: "",
                });
            }

            setDeletingInstruction(false);
        }
    };

    const cancelDeleteInstruction = () => {
        if (deletingInstruction || deletingCondition) return; // Prevent closing while deleting
        setDeleteDialog({
            open: false,
            instructionId: null,
            isApiInstruction: false,
            instructionText: "",
            isCondition: false,
        });
    };

    const handleFileUpload = async (event) => {
        const files = event.target.files;
        if (!files || files.length === 0 || !selectedProject) {
            if (!selectedProject) {
                setDeleteDialog({
                    open: true,
                    instructionId: null,
                    isApiInstruction: false,
                    instructionText:
                        "Por favor seleccione un proyecto antes de subir archivos",
                    isError: true,
                });
            }
            return;
        }

        try {
            const file = files[0];
            await uploadFile(selectedProject, file);
            // Clear the file input
            event.target.value = "";
        } catch (error) {
            setDeleteDialog({
                open: true,
                instructionId: null,
                isApiInstruction: false,
                instructionText:
                    "Error al subir el archivo. Por favor intente nuevamente.",
                isError: true,
            });
        }
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const sizes = ["Bytes", "KB", "MB", "GB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };

    const getReferenceDetails = (condition) => {
        if (condition.reference_type === "file") {
            const file = projectFiles.find(
                (f) => f.id === condition.id_reference
            );
            return file
                ? `file: ${file.name}`
                : `file: ID ${condition.id_reference}`;
        } else if (condition.reference_type === "instruction") {
            const instruction = projectInstructions.find(
                (inst) => inst.id === condition.id_reference
            );
            return instruction
                ? `instruction: ${instruction.instruction}`
                : `instruction: ID ${condition.id_reference}`;
        }
        return `${condition.reference_type}: ${condition.id_reference}`;
    };

    const triggerFileInput = () => {
        if (!selectedProject || uploadingFile) return;
        document.getElementById("file-upload-input").click();
    };

    const handleDeleteCondition = (conditionId, conditionDescription = "") => {
        // Find condition text for display
        let displayText = conditionDescription;
        if (!displayText) {
            const condition = projectConditions.find(
                (cond) => cond.id === conditionId
            );
            displayText = condition ? condition.description : "esta condición";
        }

        // Show custom dialog
        setDeleteDialog({
            open: true,
            instructionId: conditionId,
            isApiInstruction: true, // We'll reuse this for conditions
            instructionText: displayText,
            isCondition: true, // Add flag to differentiate
        });
    };

    const handleDeleteFile = (fileId, fileName = "") => {
        // Find file name for display
        let displayText = fileName;
        if (!displayText) {
            const file = projectFiles.find((f) => f.id === fileId);
            displayText = file ? file.name : "este archivo";
        }

        // Show custom dialog
        setDeleteDialog({
            open: true,
            instructionId: fileId,
            isApiInstruction: true, // We'll reuse this for files
            instructionText: displayText,
            isFile: true, // Add flag to differentiate
        });
    };

    const handleEditCondition = (condition) => {
        // Determine which reference is selected based on reference type
        let selectedFile = "";
        let selectedInstruction = "";

        if (condition.reference_type === "file") {
            const file = projectFiles.find(
                (f) => f.id === condition.id_reference
            );
            selectedFile = file ? file.name : "";
        } else if (condition.reference_type === "instruction") {
            const instruction = projectInstructions.find(
                (inst) => inst.id === condition.id_reference
            );
            selectedInstruction = instruction ? instruction.instruction : "";
        }

        setConditionModal({
            open: true,
            description: condition.description,
            condition: condition.condition,
            referenceType: condition.reference_type,
            selectedFile: selectedFile,
            selectedInstruction: selectedInstruction,
            isEdit: true,
            editingConditionId: condition.id,
        });
    };

    return (
        <Box sx={{ p: 3 }}>
            {/* Header */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="h4" sx={{ mb: 1, fontWeight: "bold" }}>
                    {t("knowledge_base")}
                </Typography>
                <Typography variant="body1" color="textSecondary">
                    {t("knowledge_base_description")} - Cliente: Tylo
                </Typography>
            </Box>

            {/* Project Selection Card */}
            <Card
                sx={{ mb: 4, boxShadow: "none", border: "1px solid #e0e0e0" }}
            >
                <CardContent sx={{ p: 3 }}>
                    <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>
                        {t("select_project")}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{ mb: 3 }}
                    >
                        {t("select_project_description")}
                    </Typography>

                    {/* Project Selection */}
                    <Box sx={{ mb: 2 }}>
                        <Typography
                            variant="body2"
                            fontWeight="medium"
                            sx={{ mb: 2 }}
                        >
                            {t("project")}
                        </Typography>
                        <FormControl fullWidth sx={{ maxWidth: 400 }}>
                            <InputLabel
                                id="project-select-label"
                                size="small"
                                sx={{
                                    color: "#666",
                                    "&.Mui-focused": {
                                        color: "#1976d2",
                                    },
                                    "&.MuiInputLabel-shrunk": {
                                        color: "#1976d2",
                                    },
                                }}
                            >
                                {t("select_project_placeholder")}
                            </InputLabel>
                            <Select
                                labelId="project-select-label"
                                value={selectedProject || ""}
                                onChange={handleProjectChange}
                                label={t("select_project_placeholder")}
                                size="small"
                                sx={{
                                    "& .MuiSelect-select": {
                                        py: 1.25,
                                        display: "flex",
                                        alignItems: "center",
                                        minHeight: "1.4375em",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#e0e0e0",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                        {
                                            borderColor: "#1976d2",
                                        },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                        {
                                            borderColor: "#1976d2",
                                            borderWidth: "2px",
                                        },
                                }}
                            >
                                {loadingProjects ? (
                                    <MenuItem
                                        disabled
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 16,
                                                height: 16,
                                                border: "2px solid #e0e0e0",
                                                borderTop: "2px solid #1976d2",
                                                borderRadius: "50%",
                                                animation:
                                                    "spin 1s linear infinite",
                                                "@keyframes spin": {
                                                    "0%": {
                                                        transform:
                                                            "rotate(0deg)",
                                                    },
                                                    "100%": {
                                                        transform:
                                                            "rotate(360deg)",
                                                    },
                                                },
                                            }}
                                        />
                                        Cargando proyectos de Tylo...
                                    </MenuItem>
                                ) : projects.length === 0 ? (
                                    <MenuItem disabled>
                                        No hay proyectos disponibles para Tylo
                                    </MenuItem>
                                ) : (
                                    [
                                        <MenuItem
                                            key="placeholder"
                                            value=""
                                            disabled
                                            sx={{ display: "none" }}
                                        >
                                            {t("select_project_placeholder")}
                                        </MenuItem>,
                                        ...projects.map((project) => (
                                            <MenuItem
                                                key={project.id}
                                                value={project.id}
                                            >
                                                {project.name}
                                            </MenuItem>
                                        )),
                                    ]
                                )}
                            </Select>
                        </FormControl>
                    </Box>
                </CardContent>
            </Card>

            {/* Empty State */}
            {!selectedProject && (
                <Box
                    sx={{
                        textAlign: "center",
                        py: 8,
                        backgroundColor: "#fafbfc",
                        borderRadius: 2,
                        border: "1px solid #e0e0e0",
                    }}
                >
                    <FolderIcon sx={{ fontSize: 64, color: "#ccc", mb: 2 }} />
                    <Typography variant="h6" sx={{ mb: 1, color: "#666" }}>
                        {t("select_a_project")}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{ maxWidth: 400, mx: "auto" }}
                    >
                        {t("select_project_instruction")}
                    </Typography>
                </Box>
            )}

            {/* Project Content - Show when AI Support is selected */}
            {selectedProject &&
                projects.find(
                    (p) => p.id === selectedProject && p.name === "AI Support"
                ) && (
                    <Box>
                        {/* AI Support Header - Full Width */}
                        <Card
                            sx={{
                                mb: 3,
                                boxShadow: "none",
                                border: "1px solid #e0e0e0",
                                borderLeft: "4px solid #2196f3",
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#2196f3",
                                        mb: 1,
                                    }}
                                >
                                    {t("ai_support")}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                >
                                    {t("ai_support_subtitle")}
                                </Typography>
                            </CardContent>
                        </Card>

                        {/* Add Files and Instructions Forms - Side by Side */}
                        <Grid container spacing={3} sx={{ mb: 3 }}>
                            {/* Add Files Form - Left Column (6/12) */}
                            <Grid item xs={12} md={6}>
                                <Card
                                    sx={{
                                        boxShadow: "none",
                                        border: "1px solid #e0e0e0",
                                        height: "100%",
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            p: 3,
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                mb: 2,
                                            }}
                                        >
                                            <UploadIcon
                                                sx={{ mr: 1, color: "#666" }}
                                            />
                                            <Typography
                                                variant="h6"
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                {t("add_files")}
                                            </Typography>
                                        </Box>
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            sx={{ mb: 3 }}
                                        >
                                            {t("add_files_description")}
                                        </Typography>

                                        <Box
                                            onClick={triggerFileInput}
                                            sx={{
                                                border: "2px dashed #ddd",
                                                borderRadius: 2,
                                                p: 3,
                                                textAlign: "center",
                                                backgroundColor: "#fafafa",
                                                flex: 1,
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                minHeight: 120,
                                                cursor:
                                                    uploadingFile ||
                                                    !selectedProject
                                                        ? "not-allowed"
                                                        : "pointer",
                                                transition: "all 0.2s ease",
                                                "&:hover":
                                                    !uploadingFile &&
                                                    selectedProject
                                                        ? {
                                                              borderColor:
                                                                  "#2196f3",
                                                              backgroundColor:
                                                                  "#f5f9ff",
                                                          }
                                                        : {},
                                                opacity: !selectedProject
                                                    ? 0.6
                                                    : 1,
                                            }}
                                        >
                                            <input
                                                id="file-upload-input"
                                                type="file"
                                                onChange={handleFileUpload}
                                                disabled={
                                                    uploadingFile ||
                                                    !selectedProject
                                                }
                                                style={{
                                                    display: "none",
                                                }}
                                            />
                                            {uploadingFile ? (
                                                <>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent:
                                                                "center",
                                                            mb: 1.5,
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                width: 40,
                                                                height: 40,
                                                                border: "3px solid #e0e0e0",
                                                                borderTop:
                                                                    "3px solid #2196f3",
                                                                borderRadius:
                                                                    "50%",
                                                                animation:
                                                                    "spin 1s linear infinite",
                                                                "@keyframes spin":
                                                                    {
                                                                        "0%": {
                                                                            transform:
                                                                                "rotate(0deg)",
                                                                        },
                                                                        "100%": {
                                                                            transform:
                                                                                "rotate(360deg)",
                                                                        },
                                                                    },
                                                            }}
                                                        />
                                                    </Box>
                                                    <Typography
                                                        variant="body2"
                                                        color="textSecondary"
                                                        sx={{
                                                            mb: 1.5,
                                                            fontSize:
                                                                "0.875rem",
                                                        }}
                                                    >
                                                        Subiendo archivo...
                                                    </Typography>
                                                </>
                                            ) : (
                                                <>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent:
                                                                "center",
                                                            mb: 1.5,
                                                        }}
                                                    >
                                                        <UploadIcon
                                                            sx={{
                                                                fontSize: 40,
                                                                color: "#999",
                                                            }}
                                                        />
                                                    </Box>
                                                    <Typography
                                                        variant="body2"
                                                        color="textSecondary"
                                                        sx={{
                                                            mb: 1.5,
                                                            fontSize:
                                                                "0.875rem",
                                                        }}
                                                    >
                                                        {selectedProject
                                                            ? t(
                                                                  "drag_files_here"
                                                              )
                                                            : "Seleccione un proyecto primero"}
                                                    </Typography>
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        disabled={
                                                            !selectedProject ||
                                                            uploadingFile
                                                        }
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            triggerFileInput();
                                                        }}
                                                    >
                                                        {t("select_files")}
                                                    </Button>
                                                </>
                                            )}
                                        </Box>

                                        {/* Uploaded Files List */}
                                        <Box sx={{ mt: 3 }}>
                                            <Typography
                                                variant="body2"
                                                fontWeight="medium"
                                                sx={{ mb: 2 }}
                                            >
                                                {t("uploaded_files")}
                                            </Typography>
                                            {loadingFiles ? (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "center",
                                                        p: 3,
                                                        border: "1px solid #e0e0e0",
                                                        borderRadius: 1,
                                                        backgroundColor:
                                                            "#f9f9f9",
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            width: 16,
                                                            height: 16,
                                                            border: "2px solid #e0e0e0",
                                                            borderTop:
                                                                "2px solid #1976d2",
                                                            borderRadius: "50%",
                                                            animation:
                                                                "spin 1s linear infinite",
                                                            "@keyframes spin": {
                                                                "0%": {
                                                                    transform:
                                                                        "rotate(0deg)",
                                                                },
                                                                "100%": {
                                                                    transform:
                                                                        "rotate(360deg)",
                                                                },
                                                            },
                                                            mr: 1,
                                                        }}
                                                    />
                                                    <Typography
                                                        variant="caption"
                                                        color="textSecondary"
                                                    >
                                                        Cargando archivos...
                                                    </Typography>
                                                </Box>
                                            ) : projectFiles.length > 0 ? (
                                                projectFiles.map((file) => (
                                                    <Box
                                                        key={file.id}
                                                        sx={{
                                                            display: "flex",
                                                            alignItems:
                                                                "center",
                                                            p: 2,
                                                            border: "1px solid #e0e0e0",
                                                            borderRadius: 1,
                                                            mb: 1,
                                                            backgroundColor:
                                                                "#f9f9f9",
                                                        }}
                                                    >
                                                        <FileIcon
                                                            sx={{
                                                                mr: 2,
                                                                color: "#666",
                                                            }}
                                                        />
                                                        <Box sx={{ flex: 1 }}>
                                                            <Typography
                                                                variant="body2"
                                                                fontWeight="medium"
                                                            >
                                                                {file.name}
                                                            </Typography>
                                                            <Typography
                                                                variant="caption"
                                                                color="textSecondary"
                                                            >
                                                                {formatFileSize(
                                                                    file.size
                                                                )}{" "}
                                                                • {file.type}
                                                            </Typography>
                                                        </Box>
                                                        <Chip
                                                            label="processed"
                                                            size="small"
                                                            color="success"
                                                            sx={{ mr: 1 }}
                                                        />
                                                    </Box>
                                                ))
                                            ) : (
                                                <Typography
                                                    variant="caption"
                                                    color="textSecondary"
                                                    sx={{ fontStyle: "italic" }}
                                                >
                                                    No hay archivos subidos
                                                </Typography>
                                            )}
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>

                            {/* Instructions Form - Right Column (6/12) */}
                            <Grid item xs={12} md={6}>
                                <Card
                                    sx={{
                                        boxShadow: "none",
                                        border: "1px solid #e0e0e0",
                                        height: "100%",
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            p: 3,
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{ fontWeight: "bold", mb: 1 }}
                                        >
                                            {t("instructions")}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            sx={{ mb: 3 }}
                                        >
                                            {t("instructions_description")}
                                        </Typography>

                                        <TextField
                                            fullWidth
                                            multiline
                                            rows={6}
                                            placeholder={t(
                                                "enter_instructions_placeholder"
                                            )}
                                            value={newInstruction}
                                            onChange={(e) =>
                                                setNewInstruction(
                                                    e.target.value
                                                )
                                            }
                                            disabled={
                                                savingInstruction ||
                                                !selectedProject
                                            }
                                            sx={{ mb: 0 }}
                                        />
                                        <Box
                                            sx={{
                                                display: "flex",
                                                gap: 1,
                                                mt: "1rem",
                                            }}
                                        >
                                            <Button
                                                variant="contained"
                                                size="small"
                                                onClick={handleAddInstruction}
                                                disabled={
                                                    savingInstruction ||
                                                    !selectedProject ||
                                                    !newInstruction.trim()
                                                }
                                                startIcon={
                                                    savingInstruction ? (
                                                        <Box
                                                            sx={{
                                                                width: 16,
                                                                height: 16,
                                                                border: "2px solid #fff",
                                                                borderTop:
                                                                    "2px solid transparent",
                                                                borderRadius:
                                                                    "50%",
                                                                animation:
                                                                    "spin 1s linear infinite",
                                                                "@keyframes spin":
                                                                    {
                                                                        "0%": {
                                                                            transform:
                                                                                "rotate(0deg)",
                                                                        },
                                                                        "100%": {
                                                                            transform:
                                                                                "rotate(360deg)",
                                                                        },
                                                                    },
                                                            }}
                                                        />
                                                    ) : (
                                                        <SaveIcon />
                                                    )
                                                }
                                            >
                                                {savingInstruction
                                                    ? "Guardando..."
                                                    : t("save_instructions")}
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                disabled={savingInstruction}
                                            >
                                                {t("add_more")}
                                            </Button>
                                        </Box>
                                        {!selectedProject && (
                                            <Typography
                                                variant="caption"
                                                color="error"
                                                sx={{ mt: 1, display: "block" }}
                                            >
                                                Seleccione un proyecto para
                                                agregar instrucciones
                                            </Typography>
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>

                        {/* Conditions Form - Full Width */}
                        <Card
                            sx={{
                                mb: 3,
                                boxShadow: "none",
                                border: "1px solid #e0e0e0",
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 1,
                                    }}
                                >
                                    <GitBranch
                                        size={24}
                                        color="#ff9800"
                                        style={{ marginRight: "8px" }}
                                    />
                                    <Typography
                                        variant="h6"
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        {t("conditions")}
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    sx={{ mb: 3 }}
                                >
                                    {t("conditions_description")}
                                </Typography>
                                <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={<AddIcon />}
                                    onClick={handleAddCondition}
                                    sx={{
                                        backgroundColor: "#333",
                                        "&:hover": { backgroundColor: "#555" },
                                    }}
                                >
                                    {t("add_condition")}
                                </Button>
                            </CardContent>
                        </Card>

                        {/* Files List - Full Width */}
                        <Card
                            sx={{
                                mb: 3,
                                boxShadow: "none",
                                border: "1px solid #e0e0e0",
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 2,
                                    }}
                                >
                                    <FileIcon sx={{ mr: 1, color: "#666" }} />
                                    <Typography
                                        variant="h6"
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        {t("files")}
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    sx={{ mb: 3 }}
                                >
                                    {t("files_description")}
                                </Typography>

                                {loadingFiles ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            p: 4,
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 1,
                                            backgroundColor: "#f9f9f9",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 20,
                                                height: 20,
                                                border: "2px solid #e0e0e0",
                                                borderTop: "2px solid #1976d2",
                                                borderRadius: "50%",
                                                animation:
                                                    "spin 1s linear infinite",
                                                "@keyframes spin": {
                                                    "0%": {
                                                        transform:
                                                            "rotate(0deg)",
                                                    },
                                                    "100%": {
                                                        transform:
                                                            "rotate(360deg)",
                                                    },
                                                },
                                                mr: 2,
                                            }}
                                        />
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                        >
                                            Cargando archivos...
                                        </Typography>
                                    </Box>
                                ) : projectFiles.length > 0 ? (
                                    projectFiles.map((file) => (
                                        <Box
                                            key={file.id}
                                            sx={{
                                                border: "1px solid #e0e0e0",
                                                borderRadius: 1,
                                                p: 2,
                                                mb: 2,
                                                backgroundColor: "#fafafa",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Box sx={{ flex: 1, mr: 2 }}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        mb: 1,
                                                    }}
                                                >
                                                    <FileIcon
                                                        sx={{
                                                            mr: 1,
                                                            color: "#666",
                                                        }}
                                                    />
                                                    <Typography
                                                        variant="body1"
                                                        fontWeight="bold"
                                                    >
                                                        {file.name}
                                                    </Typography>
                                                </Box>
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    sx={{ mb: 1 }}
                                                >
                                                    {file.description}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                    }}
                                                >
                                                    <Chip
                                                        label={file.type}
                                                        size="small"
                                                        sx={{
                                                            backgroundColor:
                                                                "#333",
                                                            color: "white",
                                                        }}
                                                    />
                                                    <Typography
                                                        variant="caption"
                                                        color="textSecondary"
                                                    >
                                                        {formatFileSize(
                                                            file.size
                                                        )}
                                                    </Typography>
                                                    <Chip
                                                        label="processed"
                                                        size="small"
                                                        color="success"
                                                    />
                                                </Box>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 0.5,
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <Typography
                                                    variant="caption"
                                                    color="textSecondary"
                                                    sx={{
                                                        mr: 1,
                                                        lineHeight: 1,
                                                    }}
                                                >
                                                    {new Date(
                                                        file.created_at
                                                    ).toLocaleDateString(
                                                        "en-US",
                                                        {
                                                            month: "short",
                                                            day: "numeric",
                                                        }
                                                    )}
                                                </Typography>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <ViewIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                    onClick={() =>
                                                        handleDeleteFile(
                                                            file.id,
                                                            file.name
                                                        )
                                                    }
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Box>
                                        </Box>
                                    ))
                                ) : (
                                    <Box
                                        sx={{
                                            textAlign: "center",
                                            py: 6,
                                            border: "2px dashed #ddd",
                                            borderRadius: 2,
                                            backgroundColor: "#fafbfc",
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{ mb: 1, color: "#666" }}
                                        >
                                            📁 No hay archivos
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            sx={{ maxWidth: 400, mx: "auto" }}
                                        >
                                            Aún no se han subido archivos para
                                            este proyecto. Use el área de carga
                                            de arriba para subir el primer
                                            archivo.
                                        </Typography>
                                    </Box>
                                )}
                            </CardContent>
                        </Card>

                        {/* Instructions List - Full Width */}
                        <Card
                            sx={{
                                mb: 3,
                                boxShadow: "none",
                                border: "1px solid #e0e0e0",
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 2,
                                    }}
                                >
                                    <MessageSquare
                                        size={24}
                                        color="#4caf50"
                                        style={{ marginRight: "8px" }}
                                    />
                                    <Typography
                                        variant="h6"
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        {t("instructions")}
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    sx={{ mb: 3 }}
                                >
                                    {t("instructions_list_description")}
                                </Typography>

                                {loadingInstructions ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            p: 4,
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 1,
                                            backgroundColor: "#f9f9f9",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 20,
                                                height: 20,
                                                border: "2px solid #e0e0e0",
                                                borderTop: "2px solid #1976d2",
                                                borderRadius: "50%",
                                                animation:
                                                    "spin 1s linear infinite",
                                                "@keyframes spin": {
                                                    "0%": {
                                                        transform:
                                                            "rotate(0deg)",
                                                    },
                                                    "100%": {
                                                        transform:
                                                            "rotate(360deg)",
                                                    },
                                                },
                                                mr: 2,
                                            }}
                                        />
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                        >
                                            Cargando instrucciones...
                                        </Typography>
                                    </Box>
                                ) : projectInstructions.length > 0 ? (
                                    projectInstructions.map((instruction) => (
                                        <Box
                                            key={`api-${instruction.id}`}
                                            sx={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                                p: 2,
                                                mb: 1,
                                                borderRadius: 1,
                                                backgroundColor: "#fff",
                                                border: "1px solid #f0f0f0",
                                                "&:hover": {
                                                    backgroundColor: "#f8f9fa",
                                                    borderColor: "#e0e0e0",
                                                },
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: 1,
                                                    backgroundColor: "#e8f5e8",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mr: 2,
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <MessageSquare
                                                    size={20}
                                                    color="#4caf50"
                                                />
                                            </Box>
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        fontWeight: 500,
                                                        mb: 0.5,
                                                        color: "#333",
                                                    }}
                                                >
                                                    {instruction.instruction}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                    }}
                                                >
                                                    <Chip
                                                        label="Instruction"
                                                        size="small"
                                                        sx={{
                                                            backgroundColor:
                                                                "#4caf50",
                                                            color: "white",
                                                            fontSize: "0.75rem",
                                                            height: 20,
                                                        }}
                                                    />
                                                </Box>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 0.5,
                                                    flexShrink: 0,
                                                    ml: 2,
                                                }}
                                            >
                                                <Typography
                                                    variant="caption"
                                                    color="textSecondary"
                                                    sx={{
                                                        mr: 1,
                                                        lineHeight: 1,
                                                    }}
                                                >
                                                    {new Date(
                                                        instruction.created_at
                                                    ).toLocaleDateString(
                                                        "en-US",
                                                        {
                                                            month: "short",
                                                            day: "numeric",
                                                        }
                                                    )}
                                                </Typography>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <ViewIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                    onClick={() =>
                                                        handleDeleteInstruction(
                                                            instruction.id,
                                                            true
                                                        )
                                                    }
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Box>
                                        </Box>
                                    ))
                                ) : (
                                    <Box
                                        sx={{
                                            textAlign: "center",
                                            py: 6,
                                            border: "2px dashed #ddd",
                                            borderRadius: 2,
                                            backgroundColor: "#fafbfc",
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{ mb: 1, color: "#666" }}
                                        >
                                            📝 No hay instrucciones
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            sx={{ maxWidth: 400, mx: "auto" }}
                                        >
                                            Aún no se han agregado instrucciones
                                            para este proyecto. Use el
                                            formulario de arriba para agregar la
                                            primera instrucción.
                                        </Typography>
                                    </Box>
                                )}
                            </CardContent>
                        </Card>

                        {/* Conditions List - Full Width */}
                        <Card
                            sx={{
                                boxShadow: "none",
                                border: "1px solid #e0e0e0",
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 2,
                                    }}
                                >
                                    <GitBranch
                                        size={24}
                                        color="#ff9800"
                                        style={{ marginRight: "8px" }}
                                    />
                                    <Typography
                                        variant="h6"
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        {t("conditions")}
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    sx={{ mb: 3 }}
                                >
                                    {t("conditions_list_description")}
                                </Typography>

                                {loadingConditions ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            p: 4,
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 1,
                                            backgroundColor: "#f9f9f9",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 20,
                                                height: 20,
                                                border: "2px solid #e0e0e0",
                                                borderTop: "2px solid #1976d2",
                                                borderRadius: "50%",
                                                animation:
                                                    "spin 1s linear infinite",
                                                "@keyframes spin": {
                                                    "0%": {
                                                        transform:
                                                            "rotate(0deg)",
                                                    },
                                                    "100%": {
                                                        transform:
                                                            "rotate(360deg)",
                                                    },
                                                },
                                                mr: 2,
                                            }}
                                        />
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                        >
                                            Cargando condiciones...
                                        </Typography>
                                    </Box>
                                ) : projectConditions.length > 0 ? (
                                    projectConditions.map((condition) => (
                                        <Box
                                            key={condition.id}
                                            sx={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                                p: 2,
                                                mb: 1,
                                                borderRadius: 1,
                                                backgroundColor: "#fff",
                                                border: "1px solid #f0f0f0",
                                                "&:hover": {
                                                    backgroundColor: "#f8f9fa",
                                                    borderColor: "#e0e0e0",
                                                },
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: 1,
                                                    backgroundColor: "#fff3e0",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mr: 2,
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <GitBranch
                                                    size={20}
                                                    color="#ff9800"
                                                />
                                            </Box>
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        fontWeight: 500,
                                                        mb: 0.5,
                                                        color: "#333",
                                                    }}
                                                >
                                                    {condition.description}
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    sx={{ mb: 1 }}
                                                >
                                                    {condition.condition}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                    }}
                                                >
                                                    <Chip
                                                        label="Condition"
                                                        size="small"
                                                        sx={{
                                                            backgroundColor:
                                                                "#ff9800",
                                                            color: "white",
                                                            fontSize: "0.75rem",
                                                            height: 20,
                                                        }}
                                                    />
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems:
                                                                "center",
                                                            gap: 0.5,
                                                            backgroundColor:
                                                                "#f5f5f5",
                                                            px: 1,
                                                            py: 0.5,
                                                            borderRadius: 1,
                                                            border: "1px solid #e0e0e0",
                                                        }}
                                                    >
                                                        <ArrowRight
                                                            size={14}
                                                            color="#666"
                                                        />
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                color: "#666",
                                                                fontSize:
                                                                    "0.75rem",
                                                                maxWidth:
                                                                    "200px",
                                                                overflow:
                                                                    "hidden",
                                                                textOverflow:
                                                                    "ellipsis",
                                                                whiteSpace:
                                                                    "nowrap",
                                                            }}
                                                        >
                                                            {getReferenceDetails(
                                                                condition
                                                            )}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 0.5,
                                                    flexShrink: 0,
                                                    ml: 2,
                                                }}
                                            >
                                                <Typography
                                                    variant="caption"
                                                    color="textSecondary"
                                                    sx={{
                                                        mr: 1,
                                                        lineHeight: 1,
                                                    }}
                                                >
                                                    {new Date(
                                                        condition.created_at
                                                    ).toLocaleDateString(
                                                        "en-US",
                                                        {
                                                            month: "short",
                                                            day: "numeric",
                                                        }
                                                    )}
                                                </Typography>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <ViewIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                    onClick={() =>
                                                        handleEditCondition(
                                                            condition
                                                        )
                                                    }
                                                >
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                    onClick={() =>
                                                        handleDeleteCondition(
                                                            condition.id,
                                                            condition.description
                                                        )
                                                    }
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Box>
                                        </Box>
                                    ))
                                ) : (
                                    <Box
                                        sx={{
                                            textAlign: "center",
                                            py: 6,
                                            border: "2px dashed #ddd",
                                            borderRadius: 2,
                                            backgroundColor: "#fafbfc",
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{ mb: 1, color: "#666" }}
                                        >
                                            🔧 No hay condiciones
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            sx={{ maxWidth: 400, mx: "auto" }}
                                        >
                                            Aún no se han creado condiciones
                                            para este proyecto. Use el botón de
                                            arriba para agregar la primera
                                            condición.
                                        </Typography>
                                    </Box>
                                )}
                            </CardContent>
                        </Card>
                    </Box>
                )}

            {/* Project Content - Show when AI Call is selected */}
            {selectedProject &&
                projects.find(
                    (p) => p.id === selectedProject && p.name === "AI Call"
                ) && (
                    <Box>
                        {/* AI Call Header - Full Width */}
                        <Card
                            sx={{
                                mb: 3,
                                boxShadow: "none",
                                border: "1px solid #e0e0e0",
                                borderLeft: "4px solid #4caf50",
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#4caf50",
                                        mb: 1,
                                    }}
                                >
                                    {t("ai_call")}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                >
                                    {t("ai_call_subtitle")}
                                </Typography>
                            </CardContent>
                        </Card>

                        {/* Add Files and Instructions Forms - Side by Side */}
                        <Grid container spacing={3} sx={{ mb: 3 }}>
                            {/* Add Files Form - Left Column (6/12) */}
                            <Grid item xs={12} md={6}>
                                <Card
                                    sx={{
                                        boxShadow: "none",
                                        border: "1px solid #e0e0e0",
                                        height: "100%",
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            p: 3,
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                mb: 2,
                                            }}
                                        >
                                            <UploadIcon
                                                sx={{ mr: 1, color: "#666" }}
                                            />
                                            <Typography
                                                variant="h6"
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                {t("add_files")}
                                            </Typography>
                                        </Box>
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            sx={{ mb: 3 }}
                                        >
                                            {t("add_files_description")}
                                        </Typography>

                                        <Box
                                            onClick={triggerFileInput}
                                            sx={{
                                                border: "2px dashed #ddd",
                                                borderRadius: 2,
                                                p: 3,
                                                textAlign: "center",
                                                backgroundColor: "#fafafa",
                                                flex: 1,
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                minHeight: 120,
                                                cursor:
                                                    uploadingFile ||
                                                    !selectedProject
                                                        ? "not-allowed"
                                                        : "pointer",
                                                transition: "all 0.2s ease",
                                                "&:hover":
                                                    !uploadingFile &&
                                                    selectedProject
                                                        ? {
                                                              borderColor:
                                                                  "#4caf50",
                                                              backgroundColor:
                                                                  "#f1f8e9",
                                                          }
                                                        : {},
                                                opacity: !selectedProject
                                                    ? 0.6
                                                    : 1,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    mb: 1.5,
                                                }}
                                            >
                                                <UploadIcon
                                                    sx={{
                                                        fontSize: 40,
                                                        color: "#999",
                                                    }}
                                                />
                                            </Box>
                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                                sx={{
                                                    mb: 1.5,
                                                    fontSize: "0.875rem",
                                                }}
                                            >
                                                {selectedProject
                                                    ? t("drag_files_here")
                                                    : "Seleccione un proyecto primero"}
                                            </Typography>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                disabled={
                                                    !selectedProject ||
                                                    uploadingFile
                                                }
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    triggerFileInput();
                                                }}
                                            >
                                                {t("select_files")}
                                            </Button>
                                        </Box>

                                        {/* Uploaded Files List */}
                                        <Box sx={{ mt: 3 }}>
                                            <Typography
                                                variant="body2"
                                                fontWeight="medium"
                                                sx={{ mb: 2 }}
                                            >
                                                {t("uploaded_files")}
                                            </Typography>
                                            {aiCallFiles.map((file) => (
                                                <Box
                                                    key={file.id}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        p: 2,
                                                        border: "1px solid #e0e0e0",
                                                        borderRadius: 1,
                                                        mb: 1,
                                                        backgroundColor:
                                                            "#f9f9f9",
                                                    }}
                                                >
                                                    <FileIcon
                                                        sx={{
                                                            mr: 2,
                                                            color: "#666",
                                                        }}
                                                    />
                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography
                                                            variant="body2"
                                                            fontWeight="medium"
                                                        >
                                                            {file.name}
                                                        </Typography>
                                                    </Box>
                                                    <Chip
                                                        label={t(file.status)}
                                                        size="small"
                                                        color="success"
                                                        sx={{ mr: 1 }}
                                                    />
                                                </Box>
                                            ))}
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>

                            {/* Instructions Form - Right Column (6/12) */}
                            <Grid item xs={12} md={6}>
                                <Card
                                    sx={{
                                        boxShadow: "none",
                                        border: "1px solid #e0e0e0",
                                        height: "100%",
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            p: 3,
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{ fontWeight: "bold", mb: 1 }}
                                        >
                                            {t("instructions")}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            sx={{ mb: 3 }}
                                        >
                                            {t("instructions_description")}
                                        </Typography>

                                        <TextField
                                            fullWidth
                                            multiline
                                            rows={6}
                                            placeholder={t(
                                                "enter_instructions_placeholder"
                                            )}
                                            value={newInstruction}
                                            onChange={(e) =>
                                                setNewInstruction(
                                                    e.target.value
                                                )
                                            }
                                            disabled={
                                                savingInstruction ||
                                                !selectedProject
                                            }
                                            sx={{ mb: 0 }}
                                        />
                                        <Box
                                            sx={{
                                                display: "flex",
                                                gap: 1,
                                                mt: "1rem",
                                            }}
                                        >
                                            <Button
                                                variant="contained"
                                                size="small"
                                                onClick={handleAddInstruction}
                                                disabled={
                                                    savingInstruction ||
                                                    !selectedProject ||
                                                    !newInstruction.trim()
                                                }
                                                startIcon={
                                                    savingInstruction ? (
                                                        <Box
                                                            sx={{
                                                                width: 16,
                                                                height: 16,
                                                                border: "2px solid #fff",
                                                                borderTop:
                                                                    "2px solid transparent",
                                                                borderRadius:
                                                                    "50%",
                                                                animation:
                                                                    "spin 1s linear infinite",
                                                                "@keyframes spin":
                                                                    {
                                                                        "0%": {
                                                                            transform:
                                                                                "rotate(0deg)",
                                                                        },
                                                                        "100%": {
                                                                            transform:
                                                                                "rotate(360deg)",
                                                                        },
                                                                    },
                                                            }}
                                                        />
                                                    ) : (
                                                        <SaveIcon />
                                                    )
                                                }
                                            >
                                                {savingInstruction
                                                    ? "Guardando..."
                                                    : t("save_instructions")}
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                disabled={savingInstruction}
                                            >
                                                {t("add_more")}
                                            </Button>
                                        </Box>
                                        {!selectedProject && (
                                            <Typography
                                                variant="caption"
                                                color="error"
                                                sx={{ mt: 1, display: "block" }}
                                            >
                                                Seleccione un proyecto para
                                                agregar instrucciones
                                            </Typography>
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>

                        {/* Conditions Form - Full Width */}
                        <Card
                            sx={{
                                mb: 3,
                                boxShadow: "none",
                                border: "1px solid #e0e0e0",
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 1,
                                    }}
                                >
                                    <GitBranch
                                        size={24}
                                        color="#ff9800"
                                        style={{ marginRight: "8px" }}
                                    />
                                    <Typography
                                        variant="h6"
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        {t("conditions")}
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    sx={{ mb: 3 }}
                                >
                                    {t("conditions_description")}
                                </Typography>
                                <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={<AddIcon />}
                                    onClick={handleAddCondition}
                                    sx={{
                                        backgroundColor: "#333",
                                        "&:hover": { backgroundColor: "#555" },
                                    }}
                                >
                                    {t("add_condition")}
                                </Button>
                            </CardContent>
                        </Card>

                        {/* Voice Agents Section - Full Width */}
                        <Card
                            sx={{
                                mb: 3,
                                boxShadow: "none",
                                border: "1px solid #e0e0e0",
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Typography
                                    variant="h6"
                                    sx={{ fontWeight: "bold", mb: 1 }}
                                >
                                    🎤 {t("voice_agents")}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    sx={{ mb: 3 }}
                                >
                                    {t("voice_agents_description")}
                                </Typography>
                                <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={<AddIcon />}
                                    sx={{
                                        backgroundColor: "#333",
                                        "&:hover": { backgroundColor: "#555" },
                                    }}
                                >
                                    {t("add_voice_agent")}
                                </Button>
                            </CardContent>
                        </Card>

                        {/* Files List - Full Width */}
                        <Card
                            sx={{
                                mb: 3,
                                boxShadow: "none",
                                border: "1px solid #e0e0e0",
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 2,
                                    }}
                                >
                                    <FileIcon sx={{ mr: 1, color: "#666" }} />
                                    <Typography
                                        variant="h6"
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        {t("files")}
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    sx={{ mb: 3 }}
                                >
                                    {t("files_description").replace(
                                        "AI Support",
                                        t("ai_call")
                                    )}
                                </Typography>

                                {aiCallFiles.map((file) => (
                                    <Box
                                        key={file.id}
                                        sx={{
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 1,
                                            p: 2,
                                            mb: 2,
                                            backgroundColor: "#fafafa",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Box sx={{ flex: 1, mr: 2 }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    mb: 1,
                                                }}
                                            >
                                                <FileIcon
                                                    sx={{
                                                        mr: 1,
                                                        color: "#666",
                                                    }}
                                                />
                                                <Typography
                                                    variant="body1"
                                                    fontWeight="bold"
                                                >
                                                    {file.name}
                                                </Typography>
                                            </Box>
                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                                sx={{ mb: 1 }}
                                            >
                                                {t(file.description)}
                                            </Typography>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 1,
                                                }}
                                            >
                                                <Chip
                                                    label={
                                                        file.type === "document"
                                                            ? t("document")
                                                            : file.type
                                                    }
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: "#333",
                                                        color: "white",
                                                    }}
                                                />
                                                <Typography
                                                    variant="caption"
                                                    color="textSecondary"
                                                >
                                                    {file.size}
                                                </Typography>
                                                <Chip
                                                    label={t(file.status)}
                                                    size="small"
                                                    color="success"
                                                />
                                            </Box>
                                        </Box>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 0.5,
                                                flexShrink: 0,
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                color="textSecondary"
                                                sx={{
                                                    mr: 1,
                                                    lineHeight: 1,
                                                }}
                                            >
                                                {file.date}
                                            </Typography>
                                            <IconButton
                                                size="small"
                                                sx={{ p: 0.5 }}
                                            >
                                                <ViewIcon fontSize="small" />
                                            </IconButton>
                                            <IconButton
                                                size="small"
                                                sx={{ p: 0.5 }}
                                                onClick={() =>
                                                    handleDeleteFile(
                                                        file.id,
                                                        file.name
                                                    )
                                                }
                                            >
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                ))}
                            </CardContent>
                        </Card>

                        {/* Instructions List - Full Width */}
                        <Card
                            sx={{
                                mb: 3,
                                boxShadow: "none",
                                border: "1px solid #e0e0e0",
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 2,
                                    }}
                                >
                                    <MessageSquare
                                        size={24}
                                        color="#4caf50"
                                        style={{ marginRight: "8px" }}
                                    />
                                    <Typography
                                        variant="h6"
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        {t("instructions")}
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    sx={{ mb: 3 }}
                                >
                                    {t("instructions_list_description").replace(
                                        "AI Support",
                                        t("ai_call")
                                    )}
                                </Typography>

                                {loadingInstructions ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            p: 4,
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 1,
                                            backgroundColor: "#f9f9f9",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 20,
                                                height: 20,
                                                border: "2px solid #e0e0e0",
                                                borderTop: "2px solid #1976d2",
                                                borderRadius: "50%",
                                                animation:
                                                    "spin 1s linear infinite",
                                                "@keyframes spin": {
                                                    "0%": {
                                                        transform:
                                                            "rotate(0deg)",
                                                    },
                                                    "100%": {
                                                        transform:
                                                            "rotate(360deg)",
                                                    },
                                                },
                                                mr: 2,
                                            }}
                                        />
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                        >
                                            Cargando instrucciones...
                                        </Typography>
                                    </Box>
                                ) : projectInstructions.length > 0 ? (
                                    projectInstructions.map((instruction) => (
                                        <Box
                                            key={`api-call-${instruction.id}`}
                                            sx={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                                p: 2,
                                                mb: 1,
                                                borderRadius: 1,
                                                backgroundColor: "#fff",
                                                border: "1px solid #f0f0f0",
                                                "&:hover": {
                                                    backgroundColor: "#f8f9fa",
                                                    borderColor: "#e0e0e0",
                                                },
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: 1,
                                                    backgroundColor: "#e8f5e8",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mr: 2,
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <MessageSquare
                                                    size={20}
                                                    color="#4caf50"
                                                />
                                            </Box>
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        fontWeight: 500,
                                                        mb: 0.5,
                                                        color: "#333",
                                                    }}
                                                >
                                                    {instruction.instruction}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                    }}
                                                >
                                                    <Chip
                                                        label="Instruction"
                                                        size="small"
                                                        sx={{
                                                            backgroundColor:
                                                                "#4caf50",
                                                            color: "white",
                                                            fontSize: "0.75rem",
                                                            height: 20,
                                                        }}
                                                    />
                                                </Box>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 0.5,
                                                    flexShrink: 0,
                                                    ml: 2,
                                                }}
                                            >
                                                <Typography
                                                    variant="caption"
                                                    color="textSecondary"
                                                    sx={{
                                                        mr: 1,
                                                        lineHeight: 1,
                                                    }}
                                                >
                                                    {new Date(
                                                        instruction.created_at
                                                    ).toLocaleDateString(
                                                        "en-US",
                                                        {
                                                            month: "short",
                                                            day: "numeric",
                                                        }
                                                    )}
                                                </Typography>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <ViewIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                    onClick={() =>
                                                        handleDeleteInstruction(
                                                            instruction.id,
                                                            true
                                                        )
                                                    }
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Box>
                                        </Box>
                                    ))
                                ) : (
                                    <Box
                                        sx={{
                                            textAlign: "center",
                                            py: 6,
                                            border: "2px dashed #ddd",
                                            borderRadius: 2,
                                            backgroundColor: "#fafbfc",
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{ mb: 1, color: "#666" }}
                                        >
                                            📝 No hay instrucciones
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            sx={{ maxWidth: 400, mx: "auto" }}
                                        >
                                            Aún no se han agregado instrucciones
                                            para este proyecto. Use el
                                            formulario de arriba para agregar la
                                            primera instrucción.
                                        </Typography>
                                    </Box>
                                )}
                            </CardContent>
                        </Card>

                        {/* Conditions List - Full Width */}
                        <Card
                            sx={{
                                mb: 3,
                                boxShadow: "none",
                                border: "1px solid #e0e0e0",
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 2,
                                    }}
                                >
                                    <GitBranch
                                        size={24}
                                        color="#ff9800"
                                        style={{ marginRight: "8px" }}
                                    />
                                    <Typography
                                        variant="h6"
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        {t("conditions")}
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    sx={{ mb: 3 }}
                                >
                                    {t("conditions_list_description").replace(
                                        "AI Support",
                                        t("ai_call")
                                    )}
                                </Typography>

                                {loadingConditions ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            p: 4,
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 1,
                                            backgroundColor: "#f9f9f9",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 20,
                                                height: 20,
                                                border: "2px solid #e0e0e0",
                                                borderTop: "2px solid #1976d2",
                                                borderRadius: "50%",
                                                animation:
                                                    "spin 1s linear infinite",
                                                "@keyframes spin": {
                                                    "0%": {
                                                        transform:
                                                            "rotate(0deg)",
                                                    },
                                                    "100%": {
                                                        transform:
                                                            "rotate(360deg)",
                                                    },
                                                },
                                                mr: 2,
                                            }}
                                        />
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                        >
                                            Cargando condiciones...
                                        </Typography>
                                    </Box>
                                ) : projectConditions.length > 0 ? (
                                    projectConditions.map((condition) => (
                                        <Box
                                            key={condition.id}
                                            sx={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                                p: 2,
                                                mb: 1,
                                                borderRadius: 1,
                                                backgroundColor: "#fff",
                                                border: "1px solid #f0f0f0",
                                                "&:hover": {
                                                    backgroundColor: "#f8f9fa",
                                                    borderColor: "#e0e0e0",
                                                },
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: 1,
                                                    backgroundColor: "#fff3e0",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mr: 2,
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <GitBranch
                                                    size={20}
                                                    color="#ff9800"
                                                />
                                            </Box>
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        fontWeight: 500,
                                                        mb: 0.5,
                                                        color: "#333",
                                                    }}
                                                >
                                                    {condition.description}
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    sx={{ mb: 1 }}
                                                >
                                                    {condition.condition}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                    }}
                                                >
                                                    <Chip
                                                        label="Condition"
                                                        size="small"
                                                        sx={{
                                                            backgroundColor:
                                                                "#ff9800",
                                                            color: "white",
                                                            fontSize: "0.75rem",
                                                            height: 20,
                                                        }}
                                                    />
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems:
                                                                "center",
                                                            gap: 0.5,
                                                            backgroundColor:
                                                                "#f5f5f5",
                                                            px: 1,
                                                            py: 0.5,
                                                            borderRadius: 1,
                                                            border: "1px solid #e0e0e0",
                                                        }}
                                                    >
                                                        <ArrowRight
                                                            size={14}
                                                            color="#666"
                                                        />
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                color: "#666",
                                                                fontSize:
                                                                    "0.75rem",
                                                                maxWidth:
                                                                    "200px",
                                                                overflow:
                                                                    "hidden",
                                                                textOverflow:
                                                                    "ellipsis",
                                                                whiteSpace:
                                                                    "nowrap",
                                                            }}
                                                        >
                                                            {getReferenceDetails(
                                                                condition
                                                            )}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 0.5,
                                                    flexShrink: 0,
                                                    ml: 2,
                                                }}
                                            >
                                                <Typography
                                                    variant="caption"
                                                    color="textSecondary"
                                                    sx={{
                                                        mr: 1,
                                                        lineHeight: 1,
                                                    }}
                                                >
                                                    {new Date(
                                                        condition.created_at
                                                    ).toLocaleDateString(
                                                        "en-US",
                                                        {
                                                            month: "short",
                                                            day: "numeric",
                                                        }
                                                    )}
                                                </Typography>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <ViewIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                    onClick={() =>
                                                        handleEditCondition(
                                                            condition
                                                        )
                                                    }
                                                >
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                    onClick={() =>
                                                        handleDeleteCondition(
                                                            condition.id,
                                                            condition.description
                                                        )
                                                    }
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Box>
                                        </Box>
                                    ))
                                ) : (
                                    <Box
                                        sx={{
                                            textAlign: "center",
                                            py: 6,
                                            border: "2px dashed #ddd",
                                            borderRadius: 2,
                                            backgroundColor: "#fafbfc",
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{ mb: 1, color: "#666" }}
                                        >
                                            🔧 No hay condiciones
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            sx={{ maxWidth: 400, mx: "auto" }}
                                        >
                                            Aún no se han creado condiciones
                                            para este proyecto. Use el botón de
                                            arriba para agregar la primera
                                            condición.
                                        </Typography>
                                    </Box>
                                )}
                            </CardContent>
                        </Card>

                        {/* Voice Agents List - Full Width */}
                        <Card
                            sx={{
                                boxShadow: "none",
                                border: "1px solid #e0e0e0",
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 2,
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={{ fontWeight: "bold", mr: 1 }}
                                    >
                                        🎤 {t("voice_agents")}
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    sx={{ mb: 3 }}
                                >
                                    {t("voice_agents_list_description")}
                                </Typography>

                                {voiceAgents.map((agent) => (
                                    <Box key={agent.id} sx={{ mb: 3 }}>
                                        <Box
                                            sx={{
                                                border: "1px solid #e0e0e0",
                                                borderRadius: 1,
                                                p: 2,
                                                mb: 2,
                                                backgroundColor: "#f8f9fa",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Box sx={{ flex: 1, mr: 2 }}>
                                                <Typography
                                                    variant="body1"
                                                    fontWeight="bold"
                                                    sx={{ mb: 1 }}
                                                >
                                                    🎤 {t(agent.name)}
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    sx={{ mb: 1 }}
                                                >
                                                    {t(agent.description)}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                    }}
                                                >
                                                    <Chip
                                                        label={t(agent.type)}
                                                        size="small"
                                                        sx={{
                                                            backgroundColor:
                                                                "#4caf50",
                                                            color: "white",
                                                        }}
                                                    />
                                                    <Typography
                                                        variant="caption"
                                                        color="textSecondary"
                                                    >
                                                        {
                                                            agent.audioFiles
                                                                .length
                                                        }{" "}
                                                        {t("audio_files")}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 0.5,
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <Typography
                                                    variant="caption"
                                                    color="textSecondary"
                                                    sx={{
                                                        mr: 1,
                                                        lineHeight: 1,
                                                    }}
                                                >
                                                    {agent.date}
                                                </Typography>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <ViewIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Box>
                                        </Box>

                                        {/* Audio Files for this agent */}
                                        <Box sx={{ ml: 2 }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                    alignItems: "center",
                                                    mb: 1,
                                                }}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    fontWeight="medium"
                                                    sx={{ color: "#666" }}
                                                >
                                                    {t("audio_files")}
                                                </Typography>
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    startIcon={<UploadIcon />}
                                                    sx={{
                                                        minWidth: "auto",
                                                        px: 2,
                                                    }}
                                                >
                                                    {t("upload_audio")}
                                                </Button>
                                            </Box>
                                            {agent.audioFiles.map(
                                                (audioFile, index) => (
                                                    <Box
                                                        key={index}
                                                        sx={{
                                                            display: "flex",
                                                            alignItems:
                                                                "center",
                                                            p: 1.5,
                                                            border: "1px solid #e0e0e0",
                                                            borderRadius: 1,
                                                            mb: 1,
                                                            backgroundColor:
                                                                "#fff",
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                width: 8,
                                                                height: 8,
                                                                borderRadius:
                                                                    "50%",
                                                                backgroundColor:
                                                                    "#4caf50",
                                                                mr: 2,
                                                            }}
                                                        />
                                                        <Typography
                                                            variant="body2"
                                                            fontWeight="medium"
                                                            sx={{ flex: 1 }}
                                                        >
                                                            {audioFile.name}
                                                        </Typography>
                                                        <Typography
                                                            variant="caption"
                                                            color="textSecondary"
                                                            sx={{ mr: 2 }}
                                                        >
                                                            {audioFile.size}
                                                        </Typography>
                                                        <Typography
                                                            variant="caption"
                                                            color="textSecondary"
                                                            sx={{ mr: 2 }}
                                                        >
                                                            {audioFile.duration}
                                                        </Typography>
                                                        <Chip
                                                            label={t(
                                                                audioFile.status
                                                            )}
                                                            size="small"
                                                            color="success"
                                                        />
                                                    </Box>
                                                )
                                            )}
                                        </Box>
                                    </Box>
                                ))}
                            </CardContent>
                        </Card>
                    </Box>
                )}

            {/* Other Projects Content - Only show for projects other than AI Support and AI Call */}
            {selectedProject &&
                projects.find((p) => p.id === selectedProject) &&
                !projects.find(
                    (p) =>
                        p.id === selectedProject &&
                        (p.name === "AI Support" || p.name === "AI Call")
                ) && (
                    <Card
                        sx={{ boxShadow: "none", border: "1px solid #e0e0e0" }}
                    >
                        <CardContent sx={{ p: 3 }}>
                            <Typography
                                variant="h6"
                                sx={{ mb: 3, fontWeight: "bold" }}
                            >
                                {t("project_documents")} -{" "}
                                {
                                    projects.find(
                                        (p) => p.id === selectedProject
                                    )?.name
                                }
                            </Typography>

                            <Box
                                sx={{
                                    textAlign: "center",
                                    py: 6,
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: 2,
                                    border: "2px dashed #ddd",
                                }}
                            >
                                <FolderIcon
                                    sx={{ fontSize: 48, color: "#999", mb: 2 }}
                                />
                                <Typography
                                    variant="h6"
                                    sx={{ mb: 1, color: "#666" }}
                                >
                                    {t("no_documents_yet")}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    sx={{ mb: 3 }}
                                >
                                    {t("upload_documents_instruction")}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                    sx={{
                                        fontStyle: "italic",
                                        backgroundColor: "#fff3cd",
                                        color: "#856404",
                                        px: 2,
                                        py: 1,
                                        borderRadius: 1,
                                        border: "1px solid #ffeaa7",
                                    }}
                                >
                                    {t("feature_coming_soon")}
                                </Typography>
                            </Box>
                        </CardContent>
                    </Card>
                )}

            {/* Custom Confirmation Dialog */}
            <Dialog
                open={deleteDialog.open}
                onClose={cancelDeleteInstruction}
                aria-labelledby="delete-dialog-title"
                aria-describedby="delete-dialog-description"
                maxWidth="sm"
                fullWidth
                disableEscapeKeyDown={deletingInstruction || deletingCondition}
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow:
                            "0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.20)",
                    },
                }}
            >
                <DialogTitle
                    id="delete-dialog-title"
                    sx={{
                        pb: 1,
                        display: "flex",
                        alignItems: "center",
                        color: deleteDialog.isError ? "#d32f2f" : "#ed6c02",
                    }}
                >
                    <Box
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            backgroundColor: deleteDialog.isError
                                ? "#ffebee"
                                : "#fff3e0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mr: 2,
                        }}
                    >
                        <Typography
                            variant="h5"
                            sx={{
                                color: deleteDialog.isError
                                    ? "#d32f2f"
                                    : "#ed6c02",
                            }}
                        >
                            {deleteDialog.isError ? "⚠️" : "🗑️"}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="h6" fontWeight="bold">
                            {deleteDialog.isError
                                ? "Error"
                                : deleteDialog.isCondition
                                ? "Confirmar eliminación de condición"
                                : "Confirmar eliminación"}
                        </Typography>
                        {!deleteDialog.isError && (
                            <Typography variant="body2" color="textSecondary">
                                Esta acción no se puede deshacer
                            </Typography>
                        )}
                    </Box>
                </DialogTitle>

                <DialogContent sx={{ pt: 1 }}>
                    <DialogContentText
                        id="delete-dialog-description"
                        sx={{ color: "text.primary", fontSize: "1rem" }}
                    >
                        {deleteDialog.isError ? (
                            deleteDialog.instructionText
                        ) : deletingInstruction || deletingCondition ? (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    py: 3,
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 24,
                                        height: 24,
                                        border: "3px solid #e0e0e0",
                                        borderTop: "3px solid #1976d2",
                                        borderRadius: "50%",
                                        animation: "spin 1s linear infinite",
                                        "@keyframes spin": {
                                            "0%": { transform: "rotate(0deg)" },
                                            "100%": {
                                                transform: "rotate(360deg)",
                                            },
                                        },
                                        mr: 2,
                                    }}
                                />
                                <Typography
                                    variant="body1"
                                    color="textSecondary"
                                >
                                    {deleteDialog.isCondition
                                        ? "Eliminando condición..."
                                        : "Eliminando instrucción..."}
                                </Typography>
                            </Box>
                        ) : (
                            <>
                                {deleteDialog.isCondition
                                    ? "¿Está seguro de que desea eliminar esta condición?"
                                    : "¿Está seguro de que desea eliminar esta instrucción?"}
                                <Box
                                    sx={{
                                        mt: 2,
                                        p: 2,
                                        backgroundColor: "#f5f5f5",
                                        borderRadius: 2,
                                        borderLeft: "4px solid #1976d2",
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontStyle: "italic",
                                            color: "#666",
                                        }}
                                    >
                                        "
                                        {deleteDialog.instructionText?.length >
                                        100
                                            ? deleteDialog.instructionText.substring(
                                                  0,
                                                  100
                                              ) + "..."
                                            : deleteDialog.instructionText}
                                        "
                                    </Typography>
                                </Box>
                            </>
                        )}
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ p: 3, pt: 1 }}>
                    {deleteDialog.isError ? (
                        <Button
                            onClick={cancelDeleteInstruction}
                            variant="contained"
                            sx={{
                                minWidth: 100,
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: "bold",
                            }}
                        >
                            Entendido
                        </Button>
                    ) : (
                        <>
                            <Button
                                onClick={cancelDeleteInstruction}
                                variant="outlined"
                                disabled={
                                    deletingInstruction || deletingCondition
                                }
                                sx={{
                                    minWidth: 100,
                                    borderRadius: 2,
                                    textTransform: "none",
                                    color:
                                        deletingInstruction || deletingCondition
                                            ? "#ccc"
                                            : "#666",
                                    borderColor:
                                        deletingInstruction || deletingCondition
                                            ? "#eee"
                                            : "#ddd",
                                    "&:hover": !(
                                        deletingInstruction || deletingCondition
                                    )
                                        ? {
                                              borderColor: "#bbb",
                                              backgroundColor: "#f5f5f5",
                                          }
                                        : {},
                                }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={confirmDeleteInstruction}
                                variant="contained"
                                color="error"
                                disabled={
                                    deletingInstruction || deletingCondition
                                }
                                sx={{
                                    minWidth: 100,
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    ml: 1,
                                    opacity:
                                        deletingInstruction || deletingCondition
                                            ? 0.7
                                            : 1,
                                }}
                                startIcon={
                                    deletingInstruction || deletingCondition ? (
                                        <Box
                                            sx={{
                                                width: 16,
                                                height: 16,
                                                border: "2px solid #fff",
                                                borderTop:
                                                    "2px solid transparent",
                                                borderRadius: "50%",
                                                animation:
                                                    "spin 1s linear infinite",
                                                "@keyframes spin": {
                                                    "0%": {
                                                        transform:
                                                            "rotate(0deg)",
                                                    },
                                                    "100%": {
                                                        transform:
                                                            "rotate(360deg)",
                                                    },
                                                },
                                            }}
                                        />
                                    ) : null
                                }
                            >
                                {deletingInstruction || deletingCondition
                                    ? "Eliminando..."
                                    : "Eliminar"}
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>

            {/* Add Condition Modal */}
            <Dialog
                open={conditionModal.open}
                onClose={handleConditionModalClose}
                aria-labelledby="condition-modal-title"
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow:
                            "0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.20)",
                    },
                }}
            >
                <DialogTitle
                    id="condition-modal-title"
                    sx={{
                        pb: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h6" fontWeight="bold">
                            {conditionModal.isEdit
                                ? "Edit Condition"
                                : "Add New Condition"}
                        </Typography>
                    </Box>
                    <IconButton
                        aria-label="close"
                        onClick={handleConditionModalClose}
                        sx={{ color: "#666" }}
                    >
                        ×
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ pt: 1 }}>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{ mb: 3 }}
                    >
                        {conditionModal.isEdit
                            ? "Update the condition settings below"
                            : "Create a condition that determines when to use specific files or instructions"}
                    </Typography>

                    <Box sx={{ mb: 3 }}>
                        <Typography
                            variant="body2"
                            fontWeight="medium"
                            sx={{ mb: 1 }}
                        >
                            Description
                        </Typography>
                        <TextField
                            fullWidth
                            placeholder="Brief description of this condition"
                            value={conditionModal.description}
                            onChange={(e) =>
                                setConditionModal((prev) => ({
                                    ...prev,
                                    description: e.target.value,
                                }))
                            }
                            size="small"
                        />
                    </Box>

                    <Box sx={{ mb: 3 }}>
                        <Typography
                            variant="body2"
                            fontWeight="medium"
                            sx={{ mb: 1 }}
                        >
                            Condition
                        </Typography>
                        <TextField
                            fullWidth
                            multiline
                            rows={3}
                            placeholder="Describe when this condition should be triggered (e.g., 'If user asks about pricing')"
                            value={conditionModal.condition}
                            onChange={(e) =>
                                setConditionModal((prev) => ({
                                    ...prev,
                                    condition: e.target.value,
                                }))
                            }
                            size="small"
                        />
                    </Box>

                    <Box sx={{ mb: 3 }}>
                        <Typography
                            variant="body2"
                            fontWeight="medium"
                            sx={{ mb: 1 }}
                        >
                            Reference Type
                        </Typography>
                        <FormControl fullWidth size="small">
                            <Select
                                value={conditionModal.referenceType}
                                onChange={(e) =>
                                    setConditionModal((prev) => ({
                                        ...prev,
                                        referenceType: e.target.value,
                                    }))
                                }
                            >
                                <MenuItem value="file">File</MenuItem>
                                <MenuItem value="instruction">
                                    Instruction
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    {conditionModal.referenceType === "file" && (
                        <Box sx={{ mb: 3 }}>
                            <Typography
                                variant="body2"
                                fontWeight="medium"
                                sx={{ mb: 1 }}
                            >
                                Select File
                            </Typography>
                            <FormControl fullWidth size="small">
                                <Select
                                    value={conditionModal.selectedFile}
                                    onChange={(e) =>
                                        setConditionModal((prev) => ({
                                            ...prev,
                                            selectedFile: e.target.value,
                                        }))
                                    }
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>
                                        Select a file
                                    </MenuItem>
                                    {projectFiles.map((file) => (
                                        <MenuItem
                                            key={file.id}
                                            value={file.name}
                                        >
                                            {file.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    )}

                    {conditionModal.referenceType === "instruction" && (
                        <Box sx={{ mb: 3 }}>
                            <Typography
                                variant="body2"
                                fontWeight="medium"
                                sx={{ mb: 1 }}
                            >
                                Select Instruction
                            </Typography>
                            <FormControl fullWidth size="small">
                                <Select
                                    value={conditionModal.selectedInstruction}
                                    onChange={(e) =>
                                        setConditionModal((prev) => ({
                                            ...prev,
                                            selectedInstruction: e.target.value,
                                        }))
                                    }
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>
                                        Select an instruction
                                    </MenuItem>
                                    {projectInstructions.map((instruction) => (
                                        <MenuItem
                                            key={instruction.id}
                                            value={instruction.instruction}
                                        >
                                            {instruction.instruction.length > 50
                                                ? instruction.instruction.substring(
                                                      0,
                                                      50
                                                  ) + "..."
                                                : instruction.instruction}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    )}
                </DialogContent>

                <DialogActions sx={{ p: 3, pt: 1 }}>
                    <Button
                        onClick={handleConditionModalClose}
                        variant="outlined"
                        disabled={savingCondition || updatingCondition}
                        sx={{
                            minWidth: 100,
                            borderRadius: 2,
                            textTransform: "none",
                            color:
                                savingCondition || updatingCondition
                                    ? "#ccc"
                                    : "#666",
                            borderColor:
                                savingCondition || updatingCondition
                                    ? "#eee"
                                    : "#ddd",
                            "&:hover": !(savingCondition || updatingCondition)
                                ? {
                                      borderColor: "#bbb",
                                      backgroundColor: "#f5f5f5",
                                  }
                                : {},
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConditionModalSave}
                        variant="contained"
                        disabled={
                            savingCondition ||
                            updatingCondition ||
                            !conditionModal.description.trim() ||
                            !conditionModal.condition.trim()
                        }
                        startIcon={
                            savingCondition || updatingCondition ? (
                                <Box
                                    sx={{
                                        width: 16,
                                        height: 16,
                                        border: "2px solid #fff",
                                        borderTop: "2px solid transparent",
                                        borderRadius: "50%",
                                        animation: "spin 1s linear infinite",
                                        "@keyframes spin": {
                                            "0%": { transform: "rotate(0deg)" },
                                            "100%": {
                                                transform: "rotate(360deg)",
                                            },
                                        },
                                    }}
                                />
                            ) : null
                        }
                        sx={{
                            minWidth: 100,
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: "bold",
                            ml: 1,
                            backgroundColor: "#333",
                            "&:hover": { backgroundColor: "#555" },
                            opacity:
                                savingCondition || updatingCondition ? 0.8 : 1,
                        }}
                    >
                        {savingCondition || updatingCondition
                            ? conditionModal.isEdit
                                ? "Actualizando..."
                                : "Guardando..."
                            : conditionModal.isEdit
                            ? "Update Condition"
                            : "Add Condition"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default KnowledgeBase;
